<template>
  <div class="new-layout">
    <div class="new-layout-bg">
      <div class="new-content">
        <div  class="title">“地平线计划”照亮佐戈依达村，公益行动温暖乡村</div>
        <div style="color: rgba(80, 80, 80, 0.7);margin-top: 6px" >2025年05月15日 18:11 贵州</div>
        <div class="content">
          <img class="new-icon" src="../../assets/may_1.jpg">
          <div class="ds-ct">
            近日，一场洋溢温暖与希望的公益行动在四川省西昌市新桥镇佐戈依达村圆满收官。由“地平线计划”牵头，联合江苏力浦交通照明有限公司、江苏汉和日用品有限公司、扬州柏顺酒店用品有限公司、吴江柏高纺织有限公司及爱心人士李坤、吴明、孙凯、许剑锋，为佐戈依达村捐赠并安装价值20多万元的太阳能路灯，切实改善村庄夜间出行条件。
          </div>
          <img class="new-icon" src="../../assets/may_5.jpg">
          <div class="ds-ct">
            佐戈依达村地处四川省西昌市县城西南10公里，幅员5.6平方公里，下辖4个村民小组，常住人口410户2200人，其中脱贫户90户461人、监测户27户123人。随着生活水平提高，夜间出行不便成为村民难题，安装路灯迫在眉睫。
          </div>
          <img class="new-icon" src="../../assets/may_2.jpg">
          <div class="ds-ct">
            “地平线计划”由上述爱心企业的企业家及爱心人士组成，秉持“超越极限的脚步，永不落山的公益”理念，不远千里奔赴村庄。此次捐赠的120盏太阳能LED路灯节能环保、亮度适中、寿命长，前期由凉善公益对接需求、协调资源。
          </div>

          <img class="new-icon" src="../../assets/may_3.jpg">
          <div class="ds-ct">
            抵达后，企业家与村民分工协作，完成灯杆组装、立杆、调试等工作。当夜幕降临时，路灯亮起，村民感慨“路灯亮了，世界就亮了”。路灯不仅便利出行、消除隐患，更提升村庄形象，助力和美乡村建设。
          </div>
          <img class="new-icon" src="../../assets/may_11.png">
          <div class="ds-ct">
            公益行动持续延伸：安装结束后，企业家们马不停蹄前往美姑县龙门乡塔哈村小学，深入了解支教老师的工作环境与贫困学生的学习生活情况。他们向学校捐赠了足球衣、篮球衣等运动装备及书包、文具、图书等物资，鼓励学生们坚持学业、追逐梦想，同时向坚守乡村教育一线的支教老师致以敬意，用实际行动为乡村教育注入温暖与力量。
          </div>
          <img class="new-icon" src="../../assets/may_6.jpg">
          <div class="ds-ct">
            此次行动彰显爱心企业与人士的社会担当。期待更多力量关注乡村建设，让公益之光照亮更多角落，助力乡村迈向美好未来。
          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      statusBarHeight: 60,
    };

  },

  methods: {


    back() {
      window.history.back(-1);
    },
  },
  mounted() {


  },
};

</script>

<style lang="scss" scoped>
.new-layout {

  position: relative;

  .new-layout-bg {
    background: #F0F4FF;
    position: relative;

  }


  .correlation-new {
    background: #ffffff;
    padding: 10px;
    padding-bottom: 0;
    margin-top: 10px;


    .correlation-new-title {
      display: flex;
      justify-content: flex-start;
      align-items: center;

      padding-top: 6px;
      //padding-bottom: 14px;
      font-size: 18px;
      font-weight: 500;
      color: #333333;

      .mark-view {
        height: 19px;
        width: 2px;
        border-radius: 5px;
        background: #3E74F8;
      }

      .dels {
        margin-left: 6px;
      }
    }
  }

  .new-content {

    background: #ffffff;
    color: #333333;
    padding-left: 12px;
    padding-right: 12px;
    padding-top: 12px;
    font-size: 14px;
    display: flex;
    justify-content: center;
    flex-direction:column;







    .content {
      padding-top: 16px;
      padding-bottom: 16px;
      letter-spacing: 0;
      line-height: 26px;
      text-align: center;
      .ds-ct{
        text-align: justify;
      }


      .new-icon {
        text-align: justify;
        width: 80%;
        border-radius: 10px;
        padding-top: 12px;
        padding-bottom: 12px;
      }

    }

    .title {
      margin-top: 30px;
      font-size: 20px;
      font-weight: bold;
    }

  }


}
</style>
